import {
  GET_FAMILYCONTACTTYPE,
  GET_FAMILYCONTACTTYPE_SUCCESS,
  GET_FAMILYCONTACTTYPE_FAIL,
  DELETE_FAMILYCONTACTTYPE,
  DELETE_FAMILYCONTACTTYPE_SUCCESS,
  DELETE_FAMILYCONTACTTYPE_FAIL,
  UPDATE_FAMILYCONTACTTYPE,
  UPDATE_FAMILYCONTACTTYPE_SUCCESS,
  UPDATE_FAMILYCONTACTTYPE_FAIL,
  ADD_NEW_FAMILYCONTACTTYPE,
  ADD_FAMILYCONTACTTYPE_SUCCESS,
  ADD_FAMILYCONTACTTYPE_FAIL,
  FAMILYCONTACTTYPE_LOADING,
  FAMILYCONTACTTYPE_RESET,
} from "./actionType";

export const resetFamilyContactTypeState = (actionType) => ({
  type: FAMILYCONTACTTYPE_RESET,
  payload: { actionType },
});

export const getFamilyContactTypeSuccess = (actionType, data) => ({
  type: GET_FAMILYCONTACTTYPE_SUCCESS,
  payload: { actionType, data },
});

export const getFamilyContactTypeFail = (actionType, error) => ({
  type: GET_FAMILYCONTACTTYPE_FAIL,
  payload: { actionType, error },
});

export const getFamilyContactType = data => ({
  type: GET_FAMILYCONTACTTYPE,
  payload: data,
});

export const getFamilyContactTypeLoading = () => ({
  type: FAMILYCONTACTTYPE_LOADING
});

export const deleteFamilyContactType = data => ({
  type: DELETE_FAMILYCONTACTTYPE,
  payload: data,
});

export const deleteFamilyContactTypeSuccess = data => ({
  type: DELETE_FAMILYCONTACTTYPE_SUCCESS,
  payload: data,
});

export const deleteFamilyContactTypeFail = error => ({
  type: DELETE_FAMILYCONTACTTYPE_FAIL,
  payload: error,
});

export const updateFamilyContactType = data => ({
  type: UPDATE_FAMILYCONTACTTYPE,
  payload: data,
});

export const updateFamilyContactTypeFail = error => ({
  type: UPDATE_FAMILYCONTACTTYPE_FAIL,
  payload: error,
});

export const updateFamilyContactTypeSuccess = data => ({
  type: UPDATE_FAMILYCONTACTTYPE_SUCCESS,
  payload: data,
});

export const addNewFamilyContactType = data => ({
  type: ADD_NEW_FAMILYCONTACTTYPE,
  payload: data,
});

export const addFamilyContactTypeSuccess = data => ({
  type: ADD_FAMILYCONTACTTYPE_SUCCESS,
  payload: data,
});

export const addFamilyContactTypeFail = error => ({
  type: ADD_FAMILYCONTACTTYPE_FAIL,
  payload: error,
});